import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3","key":"svg-0"}],["path",{"d":"M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3","key":"svg-1"}]]

const IconZodiacAquarius = createReactComponent('outline', 'zodiac-aquarius', 'ZodiacAquarius', __iconNode);

export default IconZodiacAquarius;